import React, { useEffect, useState } from "react";
import CarouselComponent from "./Components/Carousel/Carousel";
import { Box, Button, Typography } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { VEHICLES as FALLBACK_VEHICLES } from "./helpers/Constants";
import { vehicleCodeChanger } from "./helpers/vehicleCodeChanger";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const theme = createTheme({
  palette: {
    primary: { main: "#1C2541" },
    secondary: { main: "#EE8013" },
  },
});

const GROUP_ORDER = [
  "O","A","B","C","C1","C2",
  "D","D1","D2","E","E1","E2",
  "EL","EL1","EL2","EL3",
  "F","F1","G",
  "H","H1","H2",
  "I","J","J1","J2",
  "K","L","LD","L1","L2",
  "M","M1","M2",
];

const sortByGroup = (list) =>
  [...list].sort((a, b) => {
    const ia = GROUP_ORDER.indexOf(vehicleCodeChanger(a.code));
    const ib = GROUP_ORDER.indexOf(vehicleCodeChanger(b.code));
    return (ia === -1 ? 999 : ia) - (ib === -1 ? 999 : ib);
  });

const HomeFleetCarousel = ({ onReserveClick }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [vehicles, setVehicles] = useState(() => sortByGroup(FALLBACK_VEHICLES));
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    fetch(`https://app.autocrescente.com/WhyNotApi/api/fleet`)
      .then((r) => r.json())
      .then((data) => {
        if (Array.isArray(data) && data.length) setVehicles(sortByGroup(data));
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <ThemeProvider theme={theme}>
    <Box sx={{ py: { xs: 5, md: 8 }, backgroundColor: "#fff" }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: { xs: 2, md: 6 },
          mb: 3,
        }}
      >
        <Box>
          <Typography variant="h4" fontWeight={700} color="#1C2541">
            {t("fleet")}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            {t("fleetSubtitle", "Explore our diverse fleet and find the perfect vehicle for your trip.")}
          </Typography>
        </Box>
        <Button
          variant="outlined"
          endIcon={<ArrowForwardIcon />}
          onClick={() => navigate("/fleet")}
          sx={{
            borderColor: "#1C2541",
            color: "#1C2541",
            fontWeight: 600,
            whiteSpace: "nowrap",
            "&:hover": { backgroundColor: "#1C2541", color: "white" },
          }}
        >
          {t("seeAll")}
        </Button>
      </Box>

      <CarouselComponent
        onReserveClick={onReserveClick}
        width={width}
        vehicles={vehicles}
        setQuoteMessage={() => {}}
      />
    </Box>
    </ThemeProvider>
  );
};

export default HomeFleetCarousel;
